import ScanFile from './ScanFile';
import ScanWebsite from './ScanWebsite';
import KnowledgeFeedback from './KnowledgeFeedback';
import axiosInstance from "../../interceptor/axiosInstance";
import React, { createContext, useState, useEffect, useContext  } from 'react';

const ScanContext = createContext();
export const useScan = () => useContext(ScanContext);

const TabsKnowledgeCentre = ({children}) => {
  const [selectedScreen, setSelectedScreen] = useState('upload-file');
  const [isUrlScanning, setIsUrlScanning] = useState(false);

  useEffect(() => {
    fetchOrgDetails()
  }, []);

  const fetchOrgDetails = async () => {
    try {
      const response = await axiosInstance.get(`/org/org-details`);
      const data = response.data[0];  // Assuming the response contains org data
      if(response.data[0].scanning_at !== null) {
        setIsUrlScanning(true);
      } else {
        setIsUrlScanning(false);
      }
    } catch (error) {
      console.error('Error fetching organization details:', error);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-86">
      <ScanContext.Provider value={{ isUrlScanning: isUrlScanning, setIsUrlScanning: setIsUrlScanning }}>
      <main className="flex-fill mt-4">

        <div className="agent-container mb-4">
          <div className="d-flex border-bottom-grey gap-2" style={{ marginRight: '0px' }}>
            <div
              className={`tab-item tab-font ${selectedScreen == "upload-file" ? "active-tab font-black" : ""}`}
              onClick={() => { setSelectedScreen("upload-file"); }}
            >
              Upload File
            </div>
            <div
              className={`tab-item tab-font flex items-center gap-2 ${selectedScreen == "scan-website" ? "active-tab font-black" : ""}`}
              onClick={() => { setSelectedScreen("scan-website"); }}
            >
              Scan Website 
              { isUrlScanning && (
                <div className={`${selectedScreen == "scan-website" ? "loader_tab_selected" : "loader_tab_unselected"}`}></div>
              )}
            </div>
            <div
              className={`tab-item tab-font ${selectedScreen == "knowledge-feedback" ? "active-tab font-black" : ""}`}
              onClick={() => { setSelectedScreen("knowledge-feedback"); }}
            >
              Knowledge Feedback
            </div>
          </div>
        </div>

        {selectedScreen === "upload-file" ? (
          <ScanFile />
        ) : selectedScreen === "scan-website" ? (
          <ScanWebsite
            isUrlScanning={isUrlScanning}
            setIsUrlScanning={setIsUrlScanning}
            >{children}
          </ScanWebsite>
        ) : selectedScreen === "knowledge-feedback" ? (
          <KnowledgeFeedback />
        ) : null}
      </main>
      </ScanContext.Provider>
    </div>
  );
};

export default TabsKnowledgeCentre;
